import { ObservabilityPipelineHttpMetricsOverview } from "Api/observability/pipeline/types";
import { memorySizes } from "Libs/utils";
import { colorBands } from "src/organization/pages/project/environment/metrics/constant";

export const groupMetricsByStatus = (
  httpMetrics: ObservabilityPipelineHttpMetricsOverview | null | undefined
) => {
  const statuses = {};
  let minTimestamp = 0;
  let maxTimestamp = 0;
  let totalRequests = 0;

  const status = httpMetrics?.data?.timelines?.map(timeline => {
    const codes = {};

    if (minTimestamp === null || timeline.timestamp < minTimestamp) {
      minTimestamp = timeline.timestamp;
    }
    if (maxTimestamp === null || timeline.timestamp > maxTimestamp) {
      maxTimestamp = timeline.timestamp;
    }

    if (timeline.codes) {
      Object.keys(timeline.codes).forEach(status => {
        statuses[status.toUpperCase()] = true;
        codes[status.toUpperCase()] = timeline.codes[status];
        totalRequests += timeline.codes[status];
      });
    }
    return {
      ...codes,
      date: new Date(timeline.timestamp * 1000)
    };
  });

  let rate = 0;

  if (minTimestamp !== 0 && maxTimestamp !== 0) {
    rate = totalRequests / (maxTimestamp - minTimestamp);
  }

  return { data: status ?? [], statuses: Object.keys(statuses), rate };
};

type UnitType = (typeof memorySizes)[number];

const formatBytes = (bytes: number, unit: UnitType, decimals: number = 2) => {
  if (!bytes) return `${(0).toFixed(decimals)}B`;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  const i = unit
    ? memorySizes.indexOf(unit)
    : Math.floor(Math.log(bytes) / Math.log(k));

  return (
    parseFloat(String(bytes / Math.pow(k, i))).toFixed(dm) + "" + memorySizes[i]
  );
};

export default formatBytes;

export const statusColorBands = {
  "1XX": colorBands[0],
  "2XX": colorBands[1],
  "3XX": colorBands[2],
  "4XX": colorBands[3],
  "5XX": colorBands[4]
} as const;
